export const PRODUCT_CARD_RATIO = 3 / 4;
